import React, { Component } from "react";
import { Container, Box, Grid, Card, Typography, Button,IconButton, Paper, Divider ,Avatar, AppBar,Modal,TextField,} from "@mui/material";

import main_img from './assets/svt.jpg'
import main_video from './assets/hd.mp4'
import LayersIcon from '@mui/icons-material/Layers';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import AddIcon from '@mui/icons-material/Add';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import rr from "./img/one.jpeg";
import d from "./img/d.webp";
import l from "./img/l.webp";
import CloseIcon from "@mui/icons-material/Close";
import property from "./img/property.webp";
import base from '../src/base.json'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AppHeader from "./AppHeader";
import Footer from "./Footer";



export class PropertyDescription extends Component {

  constructor(props) {
    super(props)
  
    this.state = {
            data : [],
            bulder_data:[],


            ///////////////

            name :"",
            email:"",
            phone:"",
            is_enquiry_open:false,
    }
  }

componentDidMount(){
    let idd = this.props.param.id.replace(/:/g, "");

    this.setState({ is_loader_open: true }, () => {
      fetch(`${base.base_url}/property_portal/property_portal/property/retriveSinglePropertyDetails/:${idd}`, {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      })
        .then((res) => {
          return res.json();
        })
        .then((result) => {
          this.setState({
             data : result.data,
             bulder_data: result.bulder_data
          })

        })

      })
}



saveLeads=()=>{
  
  if(
    this.state.name != "",
this.state.email!= "",
this.state.phone!= ""
  ){
    fetch(`${base.base_url}/property_portal/property_portal/property/addNewLeads`, {
      headers:{
        'authorization': `Bearer ${sessionStorage.getItem('token')}`,
    'content-type':'application/json',
   // 'Access-Control-Allow-Origin': 'http://localhost:3000',
      },
          method: "post",
          body:JSON.stringify({
                      email : this.state.email,
                      phone:this.state.phone,
                      name :this.state.name,
                      propertyDetails:this.state.data[0]
            })
  
        }).then(function(response) {
          return response.json();
        })
        .then(async(data)=> {
          this.setState({
            name:'',
            email:"",
            phone:"",
            is_enquiry_open:false
          })
         alert("Enquiry done")
        });
  }else{
    alert("fill all fields")
  }
}


  render() {
    return (
      <div>
        <AppHeader/>
        <Box sx={{ minHeight: 800, width: "100%" }}>
          <Container maxWidth="xl">
            <br />
            <br />
            <br />
            <Grid container spacing={2}>
              <Grid item   size={{xs:12,sm:12,md:8}}>
                <Box
                  sx={{
                    minHeight: 300,
                    width: "100%",
                    // backgroundColor: "#fff",
                  }}
                >
                  <Grid container spacing={1}>

                    <Grid item size={{xs:12,sm:7}} >
                      <Card
                        sx={{
                          height: 300,
                          width: "100%",
                          backgroundColor: "#fff",
                          backgroundImage:`url(${base.base_url+'/'+this.state.data[0]?.property_thumbnail_img})`,
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition:'center',
                          backgroundSize:'cover',
                          borderRadius: 1,
                          boxShadow:`inset 0 -70px 70px -40px rgba(0,0,0,1);`
                        }}
                      >



<Box sx={{display:'flex',flexDirection:'row',justifyContent:'space-between',mt:34}}>
  <Box>
    <Typography sx={{fontSize:13,fontWeight:'700',color:'#fff',ml:2}}>All Photos & Videos</Typography>
  </Box>


  <Box sx={{display:'flex',flexDirection:'row'}}>
   <LayersIcon sx={{mr:1,color:'#fff'}}/> <Typography sx={{fontSize:13,fontWeight:'700',color:'#fff',mr:2}}>{this.state.data[0]?.property_imagelist.length}</Typography>
  </Box>
</Box>

                      </Card>
                    </Grid>

                    <Grid item size={{xs:12,sm:5}}>
                      <Card
                        sx={{
                          height: 146,
                          width: "100%",
                          backgroundColor: "#fff",
                          border: 1,
                          borderColor: "#e3e5ea",
                          borderRadius: 1,
                        }}
                      >


 <video width="100%" height="146" style={{objectFit:'cover'}} controls >
      <source src={base.base_url+'/'+this.state.data[0]?.property_video} type="video/mp4"/>
</video>


 </Card>


                      <Card
                        sx={{
                          height: 147,
                          width: "100%",
                          backgroundColor: "#fff",
                          backgroundImage:`url(${base.base_url+'/'+this.state.data[0]?.property_thumbnail_img})`,
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition:'center',
                          backgroundSize:'cover',
                          border: 1,
                          borderColor: "#e3e5ea",
                          borderRadius: 1,
                          mt:0.8,
                          boxShadow:`inset 0 -50px 50px -40px rgba(0,0,0,1);`
                        }}
                      >


<Box sx={{display:'flex',flexDirection:'row',justifyContent:'space-between',mt:15}}>
  <Box>
    <Typography sx={{fontSize:12,fontWeight:'700',color:'#fff',ml:2,textTransform:'uppercase'}}>Outdoors</Typography>
  </Box>


  <Box sx={{display:'flex',flexDirection:'row'}}>
   <LayersIcon sx={{mr:1,color:'#fff'}}/> <Typography sx={{fontSize:12,fontWeight:'700',color:'#fff',mr:2}}> 10</Typography>
  </Box>
</Box>




                      </Card>
                    </Grid>

                  </Grid>



<Box sx={{display:'flex',flexDirection:'row',mt:2}}>

  <Box sx={{height:50,width:90,border:0.5,borderColor:'#f2f3f5',display:'flex',justifyContent:'center',alignItems:'center'}}>
     <img style={{height:40,width:90,objectFit:'contain'}} src={base.base_url+'/'+this.state.bulder_data[0]?.builder_logo}/>
  </Box>

<Box sx={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
  <Typography sx={{fontSize:19,fontWeight:'600',ml:2,mt:1}}>{this.state.bulder_data[0]?.builder_name} <IconButton color="primary" aria-label="add to shopping cart">
  <FavoriteBorderIcon />
</IconButton></Typography>
  <Button onClick={()=>this.setState({is_enquiry_open:true})}  sx={{height:34,fontSize:11,mt:1,fontWeight:'bold'}} variant="contained" size="small">Contact</Button>
</Box>

</Box>



<Box sx={{display:'flex',flexDirection:'row',mt:2}}>

  <Box sx={{height:20,width:60,backgroundColor:'#0cb5b0',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',mr:1}}>
      <DoneAllIcon sx={{height:15,width:15,color:'#fff'}}/> <Typography sx={{fontSize:10,fontWeight:'600',color:'#fff',ml:0.5}}>RERA</Typography>
  </Box>

  <Box sx={{height:20,width:90,backgroundColor:'#d7f2e3',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',mr:1}}>
 <Typography sx={{fontSize:10,fontWeight:'600',color:'green',ml:0.5}}>No Brokrage</Typography>
  </Box>


  <Box sx={{height:20,width:140,backgroundColor:'#f7f7ff',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',mr:1}}>
      <ViewInArIcon sx={{height:15,width:15,color:'#a6a3c0'}}/> <Typography sx={{fontSize:10,fontWeight:'600',color:'#a6a3c0',ml:0.5}}>3d Floor Plan Available</Typography>
  </Box>

  <Box sx={{height:20,width:110,backgroundColor:'#f6fefe',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',mr:1}}>
      <AddIcon sx={{height:15,width:15,color:'#04afaf'}}/> <Typography sx={{fontSize:10,fontWeight:'600',color:'#04afaf',ml:0.5}}>10 Top Fecilities</Typography>
  </Box>


</Box>


<Box sx={{height:100,backgroundColor:'#f0f9ff',width:'100%',mt:2,borderRadius:1}}>
<Typography sx={{fontSize:12,color:'black',pt:1,ml:1,fontWeight:'600',textTransform:'uppercase'}}>Construction status</Typography>
<Typography sx={{fontSize:20,color:'black',pt:0.5,ml:1,fontWeight:'600'}}>{this.state.data[0]?.construction_status}</Typography>
</Box>

<Box sx={{mt:3,display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
  <Box>
    <Typography sx={{fontSize:26,fontWeight:'600'}}>₹ {this.state.data[0]?.property_price}</Typography>
    <Typography sx={{fontSize:11,fontWeight:'600',color:'grey',textTransform:'uppercase'}}>PRICE RANGE</Typography>
  </Box>

</Box>


<Divider sx={{bgcolor:'#008ffb'}}/>
<br/>


     <Box>
                        <Typography
                          variant="h2"
                          sx={{
                            fontSize: 23,
                            fontWeight: "550",
                            color: "#0a1d3e",
                          }}
                        >
                          Apartments, Villas and more
                        </Typography>
                        <Typography
                          variant="h2"
                          sx={{
                            fontSize: 12,
                            fontWeight: "500",
                            color: "#0a1d3e",
                          }}
                        >
                          in south pune
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            overflowX: "scroll",
                            mt: 2,
                            scrollbarWidth: "none",
                          }}
                        >
                          {[
                            { color: "#fef5e4", img: d ,name:"Flats or appartment"},
                            { color: "#f0f9ff", img: l ,name:"Residencial land"},
                            { color: "#d7f2e3", img: property ,name:"Independent home"},
                            { color: "#f0f9ff", img: l ,name:"Villas or home"},
                          ].map((i) => (
                            <Box sx={{ height: 330, width: 250, mr: 1 }}>
                              <Card
                                elevation={1}
                                sx={{
                                  height: 330,
                                  width: 250,
                                  borderRadius: 2,
                                  backgroundColor: i.color,
                                  backgroundImage: `url(${i.img})`,
                                  backgroundPosition: "center",
                                  backgroundSize: "cover",
                                  backgroundRepeat: "no-repeat",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 24,
                                    fontWeight: "800",
                                    textAlign: "center",
                                    mt: 5,
                                    mr:5,ml:5,
                                    color: "#445368",
                                  }}
                                >
                                  
                                 {i.name}
                                </Typography>
                              </Card>
                            </Box>
                          ))}
                        </Box>
    </Box>

<br/>
<br/>

                </Box>
              </Grid>

              <Grid item size={{xs:12,sm:12,md:4}}>
                <Card
                  sx={{ minHeight: 300, width: "100%",backgroundColor:'#f3f6ff'}}
                > {
                  /// WorkspacesIcon
                  }

                <Typography sx={{fontSize:20,fontWeight:'bold',padding:2}}>Why you should consider {this.state.bulder_data[0]?.builder_name}?</Typography>

        
                <Box sx={{display:'flex',flexDirection:'row',ml:2,mr:2,mt:1,mb:1}}>
                <WorkspacesIcon sx={{height:14,width:14,mt:0.3}}/> <Typography sx={{fontSize:13,ml:1}}>{this.state.bulder_data[0]?.builder_address}</Typography>
                </Box>

               <Divider/>

<Typography sx={{fontSize:11,mt:2,ml:2}}>Devloped by</Typography>
<Typography sx={{fontSize:15,ml:2,fontWeight:'800',color:'black',mt:0.5}}>{this.state.bulder_data[0]?.builder_name}</Typography>

<Box sx={{display:'flex',flexDirection:'row',ml:2,mt:1}}>
  <Button onClick={()=>this.setState({is_enquiry_open:true})} variant="contained" sx={{height:30,fontSize:11,mr:1}}>
   vIew Number
  </Button>

  <Button onClick={()=>this.setState({is_enquiry_open:true})} variant="outlined" sx={{height:30,fontSize:11}}>
    Contact Builder
  </Button>

</Box>

<br/>
                  
                </Card>
              </Grid>
            </Grid>
          </Container>





        </Box>
        <Footer/>




  <Box>
          <Modal
            open={this.state.is_enquiry_open}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "27%", lg: "27%" },
                  height: "65vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Paper
                    onClick={() =>
                      this.setState({
                        is_enquiry_open: false,
                        name : "",
name : "",
phone : "",
email : ""
                      })
                    }
                    elevation={5}
                    sx={{
                      height: 30,
                      width: 30,
                      borderRadius: 1,
                      backgroundColor: "#fff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mr: -1,
                      mt: -1,
                    }}
                  >
                    <CloseIcon
                      sx={{ height: 20, width: 20, color: "#2486bb" }}
                    />
                  </Paper>
                </Box>

                <Typography
                  sx={{
                    fontSize: 17,
                    fontWeight: "600",
                    color:'#008ffb',

                    paddingLeft: { xs: 2, sm: 4 },
                    mb: 2,
                  }}
                >
                Enquire Now :
                </Typography>
                <Divider />
                <Box
                  sx={{
                    overflowY: "scroll",
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      borderRadius: 10,
                    },
                  }}
                >
                  <Box
                    sx={{
                      paddingLeft: { xs: 2, sm: 4 },
                      paddingRight: { xs: 2, sm: 4 },
                      height: "76vh",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 11,
                        fontWeight: "600",
                        padding: 0.2,
                        mt: 1,
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      {" "}
                      YOUR NAME
                      <Typography sx={{ color: "red" }}>*</Typography>
                    </Typography>
                    <TextField
                      type="text"
                      InputProps={{
                        sx: { fontSize: 11, fontWeight: "600" },
                      }}
                      name="name"
                      value={this.state.name}
                      onChange={this.handleChange}
                      fullWidth
                      sx={{ backgroundColor: "#fff" }}
                      size="small"
                    />

                    <Typography
                      sx={{
                        fontSize: 11,
                        fontWeight: "600",
                        padding: 0.2,
                        mt: 1,

                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      EMAIL ID
                      <Typography sx={{ color: "red" }}>*</Typography>
                    </Typography>
                    <TextField
                      type="text"
                      InputProps={{
                        sx: { fontSize: 11, fontWeight: "600" },
                      }}
                      name="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                      sx={{ backgroundColor: "#fff" }}
                      fullWidth
                      size="small"
                    />

                    <Typography
                      sx={{
                        fontSize: 11,
                        fontWeight: "600",
                        padding: 0.2,
                        mt: 1,
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      PHONE <Typography sx={{ color: "red" }}>*</Typography>
                    </Typography>
                    <TextField
                      sx={{ backgroundColor: "#fff" }}
                      type="text"
                      InputProps={{
                        sx: { fontSize: 11, fontWeight: "600" },
                      }}
                      name="phone"
                      onChange={this.handleChange}
                      value={this.state.phone}
                      fullWidth
                      size="small"
                    />
                    
  

                    <Button
                      onClick={this.saveLeads}
                      variant="contained"
                      disableElevation
                      size="small"
                      sx={{
                        backgroundColor: "#2486bb",
                        mt: 2,
                        fontSize:11,
                        textTransform: "none",
                      }}
                    >
                    Enquire Now
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>


      </div>
    );
  }
}

export default PropertyDescription;


export function PropertyDescriptionc(props){
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams()
  return (<PropertyDescription param={param} location={location} navigate={navigate}></PropertyDescription>)}




const itemData = [
  {
    img: "https://images.unsplash.com/photo-1551963831-b3b1ca40c98e",
    title: "Breakfast",
  },
  {
    img: "https://images.unsplash.com/photo-1551782450-a2132b4ba21d",
    title: "Burger",
  },
  {
    img: "https://images.unsplash.com/photo-1522770179533-24471fcdba45",
    title: "Camera",
  },
  {
    img: "https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c",
    title: "Coffee",
  },
  {
    img: "https://images.unsplash.com/photo-1533827432537-70133748f5c8",
    title: "Hats",
  },
  {
    img: "https://images.unsplash.com/photo-1558642452-9d2a7deb7f62",
    title: "Honey",
  },
  {
    img: "https://images.unsplash.com/photo-1516802273409-68526ee1bdd6",
    title: "Basketball",
  },
  {
    img: "https://images.unsplash.com/photo-1518756131217-31eb79b20e8f",
    title: "Fern",
  },
  {
    img: "https://images.unsplash.com/photo-1597645587822-e99fa5d45d25",
    title: "Mushrooms",
  },
  {
    img: "https://images.unsplash.com/photo-1567306301408-9b74779a11af",
    title: "Tomato basil",
  },
  {
    img: "https://images.unsplash.com/photo-1471357674240-e1a485acb3e1",
    title: "Sea star",
  },
];
